module.exports = __webpack_public_path__ + "img/Ellen.2f7104c5.jpg";